import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TextField } from "@mui/material";
import PermissionsTable from "./PermissionsTable";
import { FilterLineIcon } from "../../../components/common/Icons/Icons";

// URL params the filter panel owns (counted on the Filters button)
const filterParams = ['role'];

const PermissionsContainer: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Open by default: every filter in view
  const [showFilters, setShowFilters] = useState(true);
  const [role, setRole] = useState('');

  useEffect(() => {
    setRole(searchParams.get('role') ?? '');
  }, [searchParams]);

  const handleFilter = () => {
    searchParams.delete('page'); //reset page
    role === "" ? searchParams.delete('role') : searchParams.set('role', role);
    setSearchParams(searchParams);
  };

  const handleClear = () => {
    setRole("");
    searchParams.delete('page');
    searchParams.delete('role');
    setSearchParams(searchParams);
  };

  const activeFilters = filterParams.filter((param) => searchParams.has(param)).length;

  const toolbar = (
    <button
      type="button"
      className={`btn btn-sm dt-tool-btn lp-filter-toggle ${showFilters ? 'active' : ''}`}
      onClick={() => setShowFilters(!showFilters)}
      aria-expanded={showFilters}
      aria-controls="lp-filters"
    >
      <FilterLineIcon/> Filters
      {activeFilters > 0 && <span className="lp-count">{activeFilters}</span>}
    </button>
  );

  return (
    <div className={`lp-layout ${showFilters ? '' : 'filters-hidden'}`}>
      {showFilters && (
        <aside className="lp-filters" id="lp-filters" aria-label="Filters">
          <div className="lp-filters-body">
            <div className="lp-group">
              <TextField
                id="role-search"
                label="Role"
                type="search"
                fullWidth={true}
                value={role ?? ""}
                onChange={(e) => setRole(e.target.value)}
                onKeyDown={(e) => (e.code === "Enter" ? handleFilter() : null)}
                size="small"
                autoComplete="role-name"
              />
            </div>
          </div>

          <div className="lp-filters-foot">
            <button type="button" className="btn btn-sm lp-clear-btn" onClick={handleClear}>Clear</button>
            <button type="button" className="btn btn-sm btn-primary" onClick={handleFilter}>Apply Filters</button>
          </div>
        </aside>
      )}

      <PermissionsTable toolbar={toolbar}/>
    </div>
  );
};

export default PermissionsContainer;
